// extracted by mini-css-extract-plugin
module.exports = {"side-bar":"sidebar_side-bar__2htEI","open":"sidebar_open__1ZrFY","close":"sidebar_close__391u7","container":"sidebar_container__3_3B8"};